export function linear(t) {
  return +t;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-ease/src/linear.js
// module id = 667
// module chunks = 0